<style lang="scss">
@media screen and (min-width: 55rem) {
  .buesiness-container {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    margin-top: 5rem;
    background-color: #f5f5f5;
    .buesiness {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      width: 80%;
      max-width: 1080px;
      padding-bottom: 5rem;
      .sub-header {
        margin-top: 3rem;
        font-size: 1rem;
        color: rgba(0, 0, 0, 0.25) !important;
        font-weight: 500;
        font-family: "PingFang SC", "Microsoft YaHei";
        text-transform: uppercase;
      }
      .business-header {
        font-family: "PingFang SC", "Microsoft YaHei";
        font-weight: bolder;
        font-size: 2.5rem;
        line-height: 1.4em;
        text-align: center;
        // color: #333;
        color: #000;

        margin-top: 3rem;
      }
      .numfont-container {
        margin-top: 2rem;
        display: flex;
        flex-direction: row;
        width: 100%;
        justify-content: space-around;
        .numfont {
          border-radius: 2rem;
          height: 22rem;
          width: 25%;
          margin-left: 1rem;
          display: flex;
          background-color: #fff;
          flex-direction: column;
          align-items: center;
          text-align: center;
          img {
            width: 4rem;
            height: 4rem;
            margin-top: 2rem;
          }
          .numfont-title {
            font-size: 1.8rem;
            margin-top: 1rem;
            font-family: "PingFang SC", "Microsoft YaHei";
            font-weight: 600;
            color: #000000 !important;
          }
          .introduction {
            width: 100%;
            height: 8rem;
            margin-bottom: 1rem;
            overflow: hidden;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            span {
              width: 100%;
              font-size: 0.8rem;
              font-weight: 400;
              font-family: "PingFang SC", "Microsoft YaHei";
              color: #000000 !important;
              display: block;
              white-space: nowrap;
            }
          }
          a {
            color: #f6002c;
            border-bottom: 1px solid #f6002c;
          }
        }
      }
    }
  }
}

@media screen and (max-width: 55rem) {
  .buesiness-container {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    margin-top: 5rem;
    background-color: #f5f5f5;
    .buesiness {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      width: 80%;
      max-width: 1080px;
      padding-bottom: 5rem;
      .sub-header {
        margin-top: 3rem;
        font-size: 1rem;
        color: rgba(0, 0, 0, 0.25) !important;
        font-weight: 500;
        font-family: "PingFang SC", "Microsoft YaHei";
        text-transform: uppercase;
      }
      .business-header {
        font-family: "PingFang SC", "Microsoft YaHei";
        font-weight: bolder;
        font-size: 2.5rem;
        line-height: 1.4em;
        text-align: center;
        // color: #333;
        color: #000;

        margin-top: 3rem;
      }
      .numfont-container {
        margin-top: 2rem;
        display: flex;
        flex-direction: row;
        width: 100%;
        justify-content: space-around;
        flex-wrap: wrap;
        .numfont {
          border-radius: 2rem;
          height: 22rem;
          width: 45%;
          min-width: 20rem;
          margin-left: 1rem;
          display: flex;
          background-color: #fff;
          flex-direction: column;
          align-items: center;
          text-align: center;
          margin-top: 1rem;
          img {
            width: 4rem;
            height: 4rem;
            margin-top: 2rem;
          }
          .numfont-title {
            font-size: 1.8rem;
            margin-top: 1rem;
            font-family: "PingFang SC", "Microsoft YaHei";
            font-weight: 600;
            color: #000000 !important;
          }
          .introduction {
            width: 100%;
            height: 8rem;
            margin-bottom: 1rem;
            overflow: hidden;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            span {
              width: 100%;
              font-size: 0.8rem;
              font-weight: 400;
              font-family: "PingFang SC", "Microsoft YaHei";
              color: #000000 !important;
              display: block;
              white-space: nowrap;
            }
          }
          a {
            color: #f6002c;
            border-bottom: 1px solid #f6002c;
          }
        }
      }
    }
  }
}
</style>

<template>
  <div class="buesiness-container" id="buesiness-container">
    <div class="buesiness">
      <div class="business-header">核心业务</div>
      <div class="numfont-container">
        <div class="numfont">
          <img src="/media/yintai/svg/store-1.svg" />
          <div class="numfont-title">全门店导览</div>
          <div class="introduction">
            <span> 一站式商城导航</span>
            <span> 找你想找，玩你想玩</span>
          </div>
          <a href="/store">查看更多</a>
        </div>
        <div class="numfont">
          <img src="/media/yintai/svg/store-2.svg" />
          <div class="numfont-title">喵街</div>
          <div class="introduction">
            <span> 不止于卖货，为品牌提供</span>
            <span> 品牌宣传、整合营销和内容营销阵地</span>
            <span> 创造具有潮流调性的高品质和高转化内容</span>
          </div>

          <a href="/cat">查看更多</a>
        </div>
        <div class="numfont">
          <img src="/media/yintai/svg/store-3.svg" />
          <div class="numfont-title">INTIME365会员</div>
          <div class="introduction">
            <span>在开通该项权益的</span>
            <span>所有银泰门店及喵街APP</span>
            <span>可在常规折扣及活动的基础上再享优惠</span>
          </div>
          <a href="/membership">查看更多</a>
        </div>
        <div class="numfont">
          <img src="/media/yintai/svg/store-4.svg" />
          <div class="numfont-title">云店</div>
          <div class="introduction">
            <span> 玩转新零售</span>
            <span>INTIME 365会员</span>
            <span> 银泰百货，专柜直供，一线大牌</span>
            <span> 奢侈不停，好货一站购</span>
          </div>
          <a href="/membershipStore">查看更多</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import ButtonRight from "@/yintai/view/component/ButtonRight";

export default {
  name: "home",
  components: {},
  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>
